import { Link } from "react-router-dom";

/**
 * "1,338 employers sponsored data analysts. This one is among them."
 *
 * A company page is otherwise a dead end: a member arrives from a search,
 * reads one employer, and leaves. This turns the page back into a search by
 * naming the occupation the employer sponsors most and linking to everyone
 * else who sponsored it - which is the thing the job board cannot answer and
 * the reason the CoS data is here at all.
 *
 * Renders nothing when we hold no sponsorship record for the employer, which
 * is most of them until the FOI names are mapped onto our company records.
 */
export default function OccupationCrossLink({ company, topRole }) {
  if (!topRole || !topRole.soc_code || !topRole.employers) return null;

  const first = String(company || "").split(/\s+/)[0] || "This employer";

  return (
    <aside className="occupation_crosslink">
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1355ff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>

      <p className="headline">
        {Number(topRole.employers).toLocaleString()} employers sponsored{" "}
        {topRole.soc_name.toLowerCase()}
      </p>
      <p className="sub">
        {first} is one of them. See who else did in 2025.
      </p>
      <Link to={`/explore-companies/1?soc=${topRole.soc_code}`} className="site_btn">
        See them all
      </Link>
    </aside>
  );
}
